import React from 'react';
import {useFormContext} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {NewNumberInputField, NewSelectField} from '@edna/components';
import {Label} from '@edna/components/FormField';
import {formatNumber} from '@edna/utils';

import {CUSTOM_TAX_RATE, TAX_RATE_OPTIONS, TAgentFormData} from 'src/containers/LeadCompanyClients';

export const TaxRateField = React.memo(() => {
  const {t} = useTranslation();

  const {watch} = useFormContext<TAgentFormData>();
  const resellerId = watch('resellerId');
  const taxRate = watch('taxRate');
  const documentType = watch('documentType');

  const taxRateOptions = React.useMemo(() => {
    const resellerOption = TAX_RATE_OPTIONS[resellerId]?.[documentType] ?? [];

    const options = resellerOption.map((option) => {
      if (option === CUSTOM_TAX_RATE) {
        return {
          value: option,
          label: t(`AgentCompanyClients:createForm.another`),
        };
      }

      if (option === 0) {
        return {
          value: option,
          label: t(`AgentCompanyClients:taxRateNoVat.${resellerId}`),
        };
      }

      return {value: option, label: formatNumber(option, {style: 'percent'})};
    });

    return options;
  }, [t, resellerId, documentType]);

  return (
    <>
      <Label htmlFor="taxRate">{t('AgentCompanyClients:createForm.taxRate')}</Label>
      <NewSelectField name="taxRate" options={taxRateOptions} />
      {taxRate === CUSTOM_TAX_RATE && (
        <>
          <Label htmlFor="customTaxRate">{t('AgentCompanyClients:createForm.customTaxRate')}</Label>
          <NewNumberInputField name="customTaxRate" />
        </>
      )}
    </>
  );
});

TaxRateField.displayName = 'TaxRateField';
